import React from 'react';

const Footer = () => {
  return (
    <footer 
      style={{
        position: 'relative',
        background: 'rgba(10, 10, 10, 0.35)',
        color: 'white',
        padding: '3rem 0 2rem',
        marginTop: '4rem',
        zIndex: 10,
        borderRadius: '28px',
        backdropFilter: 'blur(12px)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.25)'
      }}
    >
      {/* Top Border */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: '100px',
          height: '4px',
          background: 'linear-gradient(90deg, transparent, #FF6B35, #FFD700, transparent)',
          borderRadius: '2px'
        }}
      />

      <div 
        className="container"
        style={{
          maxWidth: '1100px',
          margin: '0 auto',
          padding: '0 1.5rem'
        }}
      >
        {/* Main Footer Grid */}
        <div 
          className="footer-main"
          style={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1.2fr',
            gap: '3rem',
            marginBottom: '3rem',
            alignItems: 'start'
          }}
        >
          
          {/* Brand Section */}
          <div className="brand-section">
            <div 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1.5rem'
              }}
            >
              <div 
                style={{
                  width: '50px',
                  height: '50px',
                  background: 'linear-gradient(135deg, #FF6B35, #FFD700)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '1.4rem',
                  boxShadow: '0 8px 25px rgba(255,107,53,0.4)'
                }}
              >
                👨‍🍳
              </div>
              <div>
                <h3 
                  style={{
                    fontSize: '1.8rem',
                    fontWeight: '800',
                    background: 'linear-gradient(135deg, #FFFFFF, #FFD700)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    margin: '0 0 0.25rem 0',
                    lineHeight: '1.2'
                  }}
                >
                  ClickaCook
                </h3>
                <p 
                  style={{
                    margin: 0,
                    fontSize: '0.9rem',
                    color: 'rgba(255,255,255,0.7)',
                    fontWeight: '500'
                  }}
                >
                  Culinary Excellence Delivered
                </p>
              </div>
            </div>
            
            <p 
              style={{
                lineHeight: '1.6',
                marginBottom: '2rem',
                color: 'rgba(255,255,255,0.8)',
                fontSize: '0.95rem',
                maxWidth: '400px'
              }}
            >
              Transforming home cooking experiences by connecting passionate chefs with food-loving families. 
              Join our community and savor the difference.
            </p>
            
            {/* Social Media */}
            <div className="social-section">
              <p 
                style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '0.9rem',
                  marginBottom: '1rem',
                  fontWeight: '600'
                }}
              >
                Follow Our Journey
              </p>
              <div 
                className="social-grid"
                style={{
                  display: 'flex',
                  gap: '0.8rem',
                  flexWrap: 'wrap'
                }}
              >
                {[
                  { name: 'Instagram', icon: '📸', color: '#E4405F' },
                  { name: 'Facebook', icon: '👍', color: '#1877F2' },
                  { name: 'Twitter', icon: '🐦', color: '#1DA1F2' },
                  { name: 'YouTube', icon: '📺', color: '#FF0000' }
                ].map((social) => (
                  <a
                    key={social.name}
                    href="#"
                    style={{
                      width: '44px',
                      height: '44px',
                      background: 'rgba(255,255,255,0.1)',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                      color: 'white',
                      fontSize: '1.2rem',
                      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                      border: '1px solid rgba(255,255,255,0.15)',
                      backdropFilter: 'blur(10px)',
                      flexShrink: 0
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = social.color;
                      e.target.style.transform = 'translateY(-3px) scale(1.1)';
                      e.target.style.boxShadow = `0 10px 25px ${social.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(255,255,255,0.1)';
                      e.target.style.transform = 'translateY(0) scale(1)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="links-section">
            <h4 
              style={{
                fontSize: '1.2rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                color: '#FFD700',
                position: 'relative',
                paddingBottom: '0.5rem'
              }}
            >
              Explore
              <div 
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  background: 'linear-gradient(90deg, #FF6B35, #FFD700)',
                  borderRadius: '1px'
                }}
              />
            </h4>
            <ul 
              style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '0.8rem'
              }}
            >
              {['Home', 'About Us', 'How It Works', 'Our Chefs', 'Testimonials', 'Blog'].map((link) => (
                <li key={link}>
                  <a
                    href="#"
                    style={{
                      color: 'rgba(255,255,255,0.8)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      fontSize: '0.95rem',
                      fontWeight: '500',
                      padding: '0.25rem 0'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#FFD700';
                      e.target.style.transform = 'translateX(5px)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = 'rgba(255,255,255,0.8)';
                      e.target.style.transform = 'translateX(0)';
                    }}
                  >
                    <span 
                      style={{
                        fontSize: '0.6rem',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      ▶
                    </span>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div className="contact-section">
            <h4 
              style={{
                fontSize: '1.2rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                color: '#FFD700',
                position: 'relative',
                paddingBottom: '0.5rem'
              }}
            >
              Stay Connected
              <div 
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '30px',
                  height: '2px',
                  background: 'linear-gradient(90deg, #FF6B35, #FFD700)',
                  borderRadius: '1px'
                }}
              />
            </h4>

            {/* Contact Info */}
            <div 
              className="contact-info"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '2rem'
              }}
            >
              {[
                { icon: '📧', text: 'hr@primeventuresglobal.com', type: 'email' },
                { icon: '📞', text: '+1 (555) 123-4567', type: 'phone' },
                { icon: '📍', text: '3 Hornton place, Kensington, London', type: 'location' }
              ].map((contact, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.8rem',
                    padding: '0.7rem',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '8px',
                    border: '1px solid rgba(255,255,255,0.1)',
                    transition: 'all 0.3s ease',
                    backdropFilter: 'blur(10px)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                    e.currentTarget.style.borderColor = 'rgba(255,107,53,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  }}
                >
                  <span style={{ fontSize: '1rem', marginTop: '0.1rem', flexShrink: 0 }}>{contact.icon}</span>
                  <span 
                    style={{
                      color: 'rgba(255,255,255,0.9)',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      lineHeight: '1.4'
                    }}
                  >
                    {contact.text}
                  </span>
                </div>
              ))}
            </div>

            {/* Newsletter */}
            
          </div>
        </div>

        {/* Footer Bottom */}
        <div 
          className="footer-bottom"
          style={{
            paddingTop: '2rem',
            borderTop: '1px solid rgba(255,255,255,0.15)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1.5rem'
          }}
        >
          <div 
            style={{
              color: 'rgba(255,255,255,0.7)',
              fontSize: '0.85rem',
              fontWeight: '500'
            }}
          >
            © 2024 ClickaCook. Crafted with ❤️ for food lovers.
          </div>
          
          <div 
            className="legal-links"
            style={{
              display: 'flex',
              gap: '2rem',
              alignItems: 'center',
              flexWrap: 'wrap'
            }}
          >
            {['Privacy Policy', 'Terms of Service', 'Cookies'].map((link) => (
              <a
                key={link}
                href="#"
                style={{
                  color: 'rgba(255,255,255,0.6)',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: '500',
                  transition: 'all 0.3s ease',
                  whiteSpace: 'nowrap'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#FFD700';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = 'rgba(255,255,255,0.6)';
                }}
              >
                {link}
              </a>
            ))}
            
            {/* Trust Badges */}
            <div 
              style={{
                display: 'flex',
                gap: '0.8rem',
                alignItems: 'center'
              }}
            >
              <div 
                style={{
                  padding: '0.3rem 0.6rem',
                  background: 'rgba(255,255,255,0.1)',
                  borderRadius: '6px',
                  fontSize: '0.75rem',
                  color: 'rgba(255,255,255,0.7)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  whiteSpace: 'nowrap'
                }}
              >
                🔒 Secure
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Responsive Styles */}
      <style>
        {`
          @media (max-width: 1024px) {
            .footer-main {
              grid-template-columns: 1fr 1fr !important;
              gap: 2.5rem !important;
            }
          }
          
          @media (max-width: 768px) {
            .footer-main {
              grid-template-columns: 1fr !important;
              gap: 2rem !important;
              text-align: center;
            }
            
            .brand-section {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            
            .social-grid {
              justify-content: center;
            }
            
            .links-section ul {
              align-items: center;
            }
            
            .contact-info {
              align-items: center;
            }
            
            .footer-bottom {
              flex-direction: column;
              text-align: center;
              gap: 1rem !important;
            }
            
            .legal-links {
              justify-content: center;
            }
          }
          
          @media (max-width: 480px) {
            .container {
              padding: 0 1rem !important;
            }
            
            .footer-main {
              gap: 1.5rem !important;
            }
            
            .legal-links {
              flex-direction: column;
              gap: 0.8rem !important;
            }
          }

          /* Smooth scrolling for anchor links */
          html {
            scroll-behavior: smooth;
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
